/**
 * Pure helpers for donation income calculations.
 * Kept framework-free so they can be unit-tested with Vitest.
 */

/** Display name for a donation; blank/missing donor => anonymous label. */
export function donorDisplayName(donation, anonymousLabel = 'Anonymous') {
  const name = (donation?.donor_name ?? '').trim()
  return name || anonymousLabel
}

/** Sum of donation amounts; missing amounts count as 0. */
export function sumDonations(donations) {
  return (donations ?? []).reduce((s, d) => s + (d?.amount ?? 0), 0)
}

/** Net result = net income + donations − expenses. */
export function computeNetResult(netIncome, totalDonations, totalExpenses) {
  return netIncome + totalDonations - totalExpenses
}
